export default "__VITE_ASSET__BMixW3oi__"